module.exports = __webpack_public_path__ + "static/media/6.36927f3b.mp3";